import { CouponsAction } from "../actions";
import { CouponType, DeviceType } from "../types";

type CouponsState = {
  error: boolean;
  loading: boolean;
  callId?: string;
  couponPrecursor?: string;
  couponType?: CouponType;
  deviceType?: DeviceType;
  
};

const INITIAL_STATE: CouponsState = {
  error: false,
  loading: false,
};

export const couponsReducer = (state = INITIAL_STATE, action: CouponsAction): CouponsState => {
  switch (action.type) {
    case "@@Coupons/CREATE_COUPON_FOR_PEP_REQUEST":
      return { loading: true, ...action.payload, ...state };
    case "@@Coupons/CREATE_COUPON_FOR_PEP_SUCCESS":
      return { loading: false, couponPrecursor: action.payload.couponPrecursor, ...state };
    case "@@Coupons/CREATE_COUPON_FOR_PEP_FAILED":
      return { loading: false, error: true }; 
    default:
      return state;
  }
};
